export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const SET_ALL_ACCOUNT = 'SET_All_ACCOUNT';
export const GET_USER_DATA = 'GET_USER_DATA';
